// extracted by mini-css-extract-plugin
module.exports = {"icon":"iconWrapper_icon__3T6Ef","iconXs":"iconWrapper_iconXs__1HeB8","iconSm":"iconWrapper_iconSm__2H4rh","iconMd":"iconWrapper_iconMd__2d8Mt","iconLg":"iconWrapper_iconLg__3rExO"};